(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Controller = App.loadClass('core::Angular/Controller');

  exports.ZoneRadioSettingsController = (function(superClass) {
    extend(ZoneRadioSettingsController, superClass);

    function ZoneRadioSettingsController(scope, transitions, zone_type, option_name, option_type, options, validation, pgis) {
      var ref, switch_step;
      this.scope = scope;
      this.transitions = transitions;
      this.zone_type = zone_type;
      this.validation = validation;
      this.pgis = pgis;
      this.makeRangeObjects = bind(this.makeRangeObjects, this);
      this.makeCropRanges = bind(this.makeCropRanges, this);
      this.loadEditData = bind(this.loadEditData, this);
      this.getZones = bind(this.getZones, this);
      this.getRangeByMin = bind(this.getRangeByMin, this);
      this.getCropRanges = bind(this.getCropRanges, this);
      this.setMapping = bind(this.setMapping, this);
      this.getMapping = bind(this.getMapping, this);
      this.loadRange = bind(this.loadRange, this);
      this.update = bind(this.update, this);
      this.updateMappings = bind(this.updateMappings, this);
      this.zoneTypeToUpper = bind(this.zoneTypeToUpper, this);
      this.multiSet = bind(this.multiSet, this);
      this.validate = bind(this.validate, this);
      this.setYieldSetting = bind(this.setYieldSetting, this);
      this.constrainProductivitySetting = bind(this.constrainProductivitySetting, this);
      this.ensureMappingIsSet = bind(this.ensureMappingIsSet, this);
      this.updateZoneObject = bind(this.updateZoneObject, this);
      this.updateFromSelect = bind(this.updateFromSelect, this);
      this.defaultSelectOptions = bind(this.defaultSelectOptions, this);
      this.getSelectOptions = bind(this.getSelectOptions, this);
      this.getDefaultCrop = bind(this.getDefaultCrop, this);
      this.dataNeedsLoaded = bind(this.dataNeedsLoaded, this);
      this.showOnMap = bind(this.showOnMap, this);
      this.setZoneObject = bind(this.setZoneObject, this);
      this.cleanup = bind(this.cleanup, this);
      this.checkMapLayers = bind(this.checkMapLayers, this);
      this.ensureZoneValuesAreSet = bind(this.ensureZoneValuesAreSet, this);
      this.formatExtraInfo = bind(this.formatExtraInfo, this);
      if ((this.pgis.field_data == null) && !this.validation.canContinue()) {
        return;
      }

      /* needs done dynamically from router */
      this.scope.units = 'bu/ac';
      this.scope.disabled.back = false;
      this.scope.multiSet = this.multiSet;
      this.scope.update = this.update;
      this.scope.option_name = option_name;
      this.scope.value_options = options;
      this.scope.option_type = option_type;
      this.scope.field_data = ((ref = this.pgis) != null ? ref.field_data : void 0) != null ? this.pgis.field_data : this.validation.getFieldData();
      this.scope.zone_object = this.setZoneObject();
      this.scope.cleanup = this.cleanup;
      this.scope.updateFromSelect = this.updateFromSelect;
      this.scope.zone_type = this.zone_type;
      this.scope.field_data.visited_settings = true;
      this.formatExtraInfo();
      this.scope.selected = {
        crop: this.getDefaultCrop()
      };
      this.scope.crops_ranges = this.makeCropRanges();
      this.scope.crops = Object.keys(this.scope.crops_ranges);
      if (this.scope.option_type === 'select') {
        this.scope.select_options = this.getSelectOptions(this.zone_type);
      }
      this.scope.validation = this.validation;
      this.scope.validate = this.validate;
      this.scope.validation.setStepScope(this.scope);
      this.scope.load_data = this.dataNeedsLoaded();
      this.scope.blocks = {
        green: {
          values: ['Irrigated', 'High', 'Soybeans'],
          color: '#3A894C'
        },
        yellow: {
          values: ['Med', 'Corn (grain)'],
          color: '#E5B032'
        },
        red: {
          values: ['Dryland', 'Low'],
          color: '#BE4948'
        },
        blue: {
          values: ['Other'],
          color: '#3286AB'
        }
      };
      this.checkMapLayers();
      if (this.scope.load_data) {
        this.loadEditData();
      } else {
        this.pgis.setZoneObject(this.scope.zone_object);
      }
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          var i, len, ref1, z;
          if (_this.zone_type === 'irrigation') {
            _this.pgis.setIrrigationZone(_this.scope.zone_object);
          }
          if (_this.zone_type === 'previous-crop') {
            _this.pgis.setPreviousCropZone(_this.scope.zone_object);
          }
          if (_this.zone_type === 'productivity') {
            _this.pgis.setProductivityZone(_this.scope.zone_object);
          }
          if (_.startsWith($transition.to().name, 'grower.fields-define')) {
            _this.scope.died_willingly = true;
          }
          if (_this.scope.option_type === 'select' || _this.scope.zone_type === 'previous-crop') {
            ref1 = _this.scope.zone_object.zones;
            for (i = 0, len = ref1.length; i < len; i++) {
              z = ref1[i];
              App.map.removeLayer(z.visible);
            }
            _this.pgis.setFieldData(null);
            return _this.pgis.setZoneObject(null);
          }
        };
      })(this));
      switch_step = this.zone_type === 'previous-crop' ? 1 : 2;
      this.scope.$parent.steps.once('switch-from', "grower.fields-define." + this.zone_type + "-settings" + switch_step, (function(_this) {
        return function(data) {
          if (data.is_forward) {
            _this.scope.field_data.visited_settings = null;
            return _this.validation.setFieldData(_this.scope.field_data);
          }
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          if (!_this.scope.died_willingly) {
            _this.validation.clearLayers();
            _this.validation.settings = {};
          }
          return _this.transitionStart();
        };
      })(this));
      this.scope.validation.validate();
      this.ensureZoneValuesAreSet();
      this.validation.setBackButtonDisable(this.scope.field_data, false);
      this.scope.$watch('selected.crop', (function(_this) {
        return function(crop, old) {
          if (crop === old) {
            return;
          }
          if (_this.scope.option_type === 'select') {
            _this.scope.select_options = _this.getSelectOptions(_this.zone_type, true);
          }
          return _this.scope.validation.validate();
        };
      })(this));
    }

    ZoneRadioSettingsController.prototype.formatExtraInfo = function() {
      var base;
      if (typeof this.scope.zone_object.extra_info === 'string') {
        this.scope.zone_object.extra_info = JSON.parse(this.scope.zone_object.extra_info);
      }
      return (base = this.scope.zone_object).extra_info != null ? base.extra_info : base.extra_info = {
        crop: '',
        units: '',
        name_add: '',
        mappings: []
      };
    };

    ZoneRadioSettingsController.prototype.ensureZoneValuesAreSet = function() {
      var i, len, ref, ref1, results, zone;
      ref = this.scope.zone_object.zones;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        zone = ref[i];
        if (((zone != null ? (ref1 = zone.settings) != null ? ref1[this.scope.option_name] : void 0 : void 0) == null) && ((zone != null ? zone.value : void 0) != null)) {
          this.update(zone.value, zone);
          results.push(zone.settings[this.scope.option_name] = zone.value);
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ZoneRadioSettingsController.prototype.checkMapLayers = function() {
      var exists, i, len, ref, results, za;
      ref = this.scope.zone_object.zones;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        za = ref[i];
        exists = false;
        App.map.eachLayer((function(_this) {
          return function(l) {
            if (l === za.visible) {
              return exists = true;
            }
          };
        })(this));
        if (!exists) {
          results.push(za.visible.addTo(App.map));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ZoneRadioSettingsController.prototype.cleanup = function() {
      delete this.scope.field_data;
      return delete this.scope.zone_object;
    };

    ZoneRadioSettingsController.prototype.setZoneObject = function() {
      var i, len, ref, z, zone;
      zone = false;
      if (this.zone_type === 'irrigation' && this.pgis.getIrrigationZone()) {
        zone = this.pgis.getIrrigationZone();
      }
      if (this.zone_type === 'previous-crop' && this.pgis.getPreviousCropZone()) {
        zone = this.pgis.getPreviousCropZone();
      }
      if (this.zone_type === 'productivity' && this.pgis.getProductivityZone()) {
        zone = this.pgis.getProductivityZone();
      }
      if (zone) {
        ref = zone.zones;
        for (i = 0, len = ref.length; i < len; i++) {
          z = ref[i];
          this.showOnMap(z, false);
        }
        return zone;
      }
      if (this.scope.option_type === 'select') {
        return this.pgis.getZoneObject();
      }
      return this.scope.$parent.field_data.zones[this.zone_type];
    };

    ZoneRadioSettingsController.prototype.showOnMap = function(zone, update) {
      var geojson;
      if (update == null) {
        update = true;
      }
      if (update) {
        geojson = L.GeoUtil.multiPolygonize(zone.visible.toGeoJSON());
        zone.geojson = geojson;
      } else {
        geojson = zone.visible.toGeoJSON();
      }
      zone.visible.clearLayers();
      L.geoJson(geojson).eachLayer((function(_this) {
        return function(l) {
          l.setStyle({
            weight: 2,
            color: zone.color,
            fillOpacity: 0.6
          });
          zone.visible.addLayer(l);
          return _this.pgis.added_layers.push(l);
        };
      })(this));
      return zone.visible.addTo(App.map);
    };

    ZoneRadioSettingsController.prototype.dataNeedsLoaded = function() {
      var no_load_modes, ref;
      no_load_modes = ['zone-add', 'irrigation-add'];
      return (ref = this.scope.field_data.process_mode, indexOf.call(no_load_modes, ref) < 0) && this.scope.option_type !== 'select';
    };

    ZoneRadioSettingsController.prototype.getDefaultCrop = function() {
      var ref, ref1;
      if (this.validation.settings.crop) {
        return this.validation.settings.crop;
      } else if ((ref = this.scope.zone_object) != null ? (ref1 = ref.extra_info) != null ? ref1.crop : void 0 : void 0) {
        return this.scope.zone_object.extra_info.crop;
      } else {
        return null;
      }
    };

    ZoneRadioSettingsController.prototype.getSelectOptions = function(type, resetWithoutDefault) {
      if (resetWithoutDefault == null) {
        resetWithoutDefault = false;
      }
      if (type === 'irrigation') {
        return this.defaultSelectOptions([
          {
            name: 'Irrigated',
            values: this.getCropRanges(),
            color: '#3A894C',
            selected: null
          }, {
            name: 'Dryland',
            values: this.getCropRanges(),
            color: '#BE4948',
            selected: null
          }
        ], resetWithoutDefault);
      } else {
        return this.defaultSelectOptions([
          {
            name: 'High',
            values: this.getCropRanges(),
            color: '#3A894C',
            selected: null
          }, {
            name: 'Med',
            values: this.getCropRanges(),
            color: '#E5B032',
            selected: null
          }, {
            name: 'Low',
            values: this.getCropRanges(),
            color: '#BE4948',
            selected: null
          }
        ], resetWithoutDefault);
      }
    };

    ZoneRadioSettingsController.prototype.defaultSelectOptions = function(options, resetWithoutDefault) {
      var i, j, len, len1, mapping, option, ref, zone;
      for (i = 0, len = options.length; i < len; i++) {
        option = options[i];
        mapping = this.getMapping(option.name);
        if (mapping == null) {
          continue;
        }
        if ((mapping.value != null) && (option.selected === 0 || !option.selected) && !resetWithoutDefault) {
          option.selected = mapping.value;
        }
        if (option.selected !== 0) {
          ref = this.getZones(option.name);
          for (j = 0, len1 = ref.length; j < len1; j++) {
            zone = ref[j];
            zone.yield_value = option.selected;
            zone.yield_range = option.selected;
            zone["yield"] = option.selected;
          }
        }
      }
      return options;
    };

    ZoneRadioSettingsController.prototype.updateFromSelect = function(setting) {
      var i, len, ref, ref1, results, zone;
      if (((ref = this.scope.zone_object) != null ? ref.extra_info : void 0) != null) {
        this.updateZoneObject();
      }
      this.ensureMappingIsSet(setting);
      this.constrainProductivitySetting(setting);
      ref1 = this.scope.zone_object.zones;
      results = [];
      for (i = 0, len = ref1.length; i < len; i++) {
        zone = ref1[i];
        if (zone.value === setting.name) {
          zone.color = setting.color;
          zone.yield_range = setting.selected;
          zone.selected_crop = this.scope.selected.crop;
          zone.zone_type = this.zone_type;
          results.push(this.showOnMap(zone));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ZoneRadioSettingsController.prototype.updateZoneObject = function() {
      this.scope.zone_object.selected_crop = this.scope.selected.crop;
      this.scope.zone_object.zone_type = this.zoneTypeToUpper(this.zone_type);
      this.scope.zone_object.extra_info.crop = this.scope.selected.crop;
      this.scope.zone_object.extra_info.name_add = this.scope.selected.crop;
      return this.scope.zone_object.extra_info.units = this.scope.units;
    };

    ZoneRadioSettingsController.prototype.ensureMappingIsSet = function(option) {
      var i, len, ref, results, zone;
      this.scope.zone_object.extra_info.crop = this.scope.selected.crop;
      this.setMapping(option.name, option.selected);
      ref = this.getZones(option.name);
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        zone = ref[i];
        zone.yield_value = option.selected;
        results.push(zone.yield_range = option.selected);
      }
      return results;
    };

    ZoneRadioSettingsController.prototype.constrainProductivitySetting = function(setting) {
      var high, i, len, low, med, option, ref;
      ref = this.scope.select_options;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        if (option.name === 'Low') {
          low = option.selected;
        }
        if (option.name === 'Med') {
          med = option.selected;
        }
        if (option.name === 'High') {
          high = option.selected;
        }
      }
      switch (setting.name) {
        case 'Low':
          if (setting.selected > med) {
            this.setYieldSetting('Med', setting.selected);
          }
          if (setting.selected > high) {
            return this.setYieldSetting('High', setting.selected);
          }
          break;
        case 'High':
          if (setting.selected < med) {
            this.setYieldSetting('Med', setting.selected);
          }
          if (setting.selected < low) {
            return this.setYieldSetting('Low', setting.selected);
          }
          break;
        case 'Med':
          if (setting.selected < low) {
            this.setYieldSetting('Low', setting.selected);
          }
          if (setting.selected > high) {
            return this.setYieldSetting('High', setting.selected);
          }
      }
    };

    ZoneRadioSettingsController.prototype.setYieldSetting = function(name, value) {
      var i, j, len, len1, ref, ref1, results, setting, zone;
      ref = this.scope.select_options;
      for (i = 0, len = ref.length; i < len; i++) {
        setting = ref[i];
        if (setting.name === name) {
          setting.selected = value;
        }
      }
      ref1 = this.getZones(name);
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        zone = ref1[j];
        results.push(zone.yield_range = value);
      }
      return results;
    };

    ZoneRadioSettingsController.prototype.validate = function(ending) {
      var average, i, j, k, len, len1, len2, option, range, ref, ref1, ref2, zone;
      this.validation.setFieldData(this.scope.field_data);
      if (this.scope.option_type === 'button') {
        ref = this.scope.zone_object.zones;
        for (i = 0, len = ref.length; i < len; i++) {
          zone = ref[i];
          if (((zone != null ? zone.value : void 0) == null) || (zone != null ? zone.value : void 0) === 'false') {
            return false;
          }
        }
      } else if (this.scope.option_type === 'select') {
        ref1 = this.scope.zone_object.zones;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          zone = ref1[j];
          if ((zone.yield_range == null) || zone.yield_range === '') {
            return false;
          }
        }
        if (!this.scope.selected.crop) {
          return false;
        }
      }
      if (ending) {
        if (this.scope.option_type === 'select') {
          ref2 = this.scope.select_options;
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            option = ref2[k];
            if (this.getZones(option.name).length === 0) {
              continue;
            }
            range = this.getRangeByMin(option.selected);
            average = (range.min + range.max) / 2;
            this.setMapping(option.name + " average", average);
          }
        }
        this.pgis.setZoneObject(this.scope.zone_object);
      }
      return true;
    };

    ZoneRadioSettingsController.prototype.multiSet = function(value) {
      var i, len, ref, z;
      ref = this.scope.zone_object.zones;
      for (i = 0, len = ref.length; i < len; i++) {
        z = ref[i];
        z.settings[this.scope.option_name] = value;
        this.update(value, z);
      }
      return this.scope.validation.validate();
    };

    ZoneRadioSettingsController.prototype.zoneTypeToUpper = function(type) {
      switch (type) {
        case 'previous-crop':
          return 'Previous Crop';
        case 'irrigation':
          return 'Irrigation';
        case 'productivity':
          return 'Productivity';
      }
    };

    ZoneRadioSettingsController.prototype.updateMappings = function(name) {
      this.formatExtraInfo();
      return this.setMapping(name);
    };

    ZoneRadioSettingsController.prototype.update = function(value, zone) {
      var color, properties, ref, ref1, ref2;
      if (((ref = this.scope) != null ? (ref1 = ref.zone_object) != null ? ref1.extra_info : void 0 : void 0) != null) {
        this.updateZoneObject();
      }
      ref2 = this.scope.blocks;
      for (color in ref2) {
        properties = ref2[color];
        if (indexOf.call(properties.values, value) >= 0) {
          zone.color = properties.color;
          zone.selected_crop = this.scope.selected.crop;
          zone.zone_type = this.zone_type;
          zone.value = value;
          zone.updated = true;
          zone.settings[this.scope.option_name] = value;
          this.updateMappings(value);
          this.showOnMap(zone);
        }
      }
      return this.pgis.setZoneObject(this.scope.zone_object);
    };

    ZoneRadioSettingsController.prototype.loadRange = function(zone) {

      /*
          This now breaks for irrigation maps due to changes to the structure of irrigation map extra_info
          The controller that processes the irrigation data has also been changed, so we can skip this if the zone is irrigation
          https://www.pivotaltracker.com/story/show/153712733
       */
      var mapping, range;
      if (this.zone_type === 'irrigation') {
        return;
      }
      if (!this.scope.selected.crop) {
        this.scope.selected.crop = 'Corn (grain)';
      }
      mapping = this.getMapping(zone.value);
      if (mapping != null) {
        range = this.getRangeByMin(mapping.value);
      }
      if (range != null) {
        return zone.yield_range = range.min;
      }
    };

    ZoneRadioSettingsController.prototype.getMapping = function(name) {
      var base, i, len, mapping, ref;
      if ((base = this.scope.zone_object.extra_info).mappings == null) {
        base.mappings = [];
      }
      ref = this.scope.zone_object.extra_info.mappings;
      for (i = 0, len = ref.length; i < len; i++) {
        mapping = ref[i];
        if (name.toLowerCase() === mapping.name.toLowerCase()) {
          return mapping;
        }
      }
      return null;
    };

    ZoneRadioSettingsController.prototype.setMapping = function(name, value) {
      var base, i, len, mapping, ref;
      if (value == null) {
        value = null;
      }

      /*
          This now breaks for irrigation maps due to changes to the structure of irrigation map extra_info
          The controller that processes the irrigation data has also been changed, so we can skip this if the zone is irrigation
          https://www.pivotaltracker.com/story/show/153712733
       */
      if (this.zone_type === 'irrigation') {
        return;
      }
      if ((base = this.scope.zone_object.extra_info).mappings == null) {
        base.mappings = [];
      }
      ref = this.scope.zone_object.extra_info.mappings;
      for (i = 0, len = ref.length; i < len; i++) {
        mapping = ref[i];
        if (name.toLowerCase() === mapping.name.toLowerCase()) {
          if (value != null) {
            mapping.value = value;
          }
          return;
        }
      }
      return this.scope.zone_object.extra_info.mappings.push({
        name: name.toLowerCase(),
        value: value != null ? value : ''
      });
    };

    ZoneRadioSettingsController.prototype.getCropRanges = function(crop) {
      if (crop == null) {
        crop = null;
      }
      return this.scope.crops_ranges[crop != null ? crop : this.scope.selected.crop];
    };

    ZoneRadioSettingsController.prototype.getRangeByMin = function(min) {
      var i, len, range, ref;
      ref = this.getCropRanges();
      for (i = 0, len = ref.length; i < len; i++) {
        range = ref[i];
        if (range.min === min) {
          return range;
        }
      }
      return null;
    };

    ZoneRadioSettingsController.prototype.getZones = function(value) {
      var base;
      if (value == null) {
        value = null;
      }
      if ((base = this.scope.zone_object).zones == null) {
        base.zones = [];
      }
      if (value == null) {
        return this.scope.zone_object.zones;
      }
      return this.scope.zone_object.zones.filter(function(zone) {
        return zone.value.toLowerCase() === value.toLowerCase();
      });
    };

    ZoneRadioSettingsController.prototype.loadEditData = function() {
      var color, i, len, properties, ref, results, zone;
      ref = this.scope.zone_object.zones;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        zone = ref[i];
        results.push((function() {
          var ref1, ref2, results1;
          ref1 = this.scope.blocks;
          results1 = [];
          for (color in ref1) {
            properties = ref1[color];
            if (ref2 = zone.value, indexOf.call(properties.values, ref2) >= 0) {
              zone.color = properties.color;
              zone.zone_type = this.zone_type;
              zone.selected_crop = this.scope.selected.crop;
              zone.settings[this.scope.option_name] = zone.value;
              this.loadRange(zone);
              results1.push(this.showOnMap(zone));
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    ZoneRadioSettingsController.prototype.makeCropRanges = function() {
      var x;
      return {
        'Corn (grain)': this.makeRangeObjects((function() {
          var i, results;
          results = [];
          for (x = i = 360; i >= 0; x = i += -20) {
            results.push(x);
          }
          return results;
        })()),
        Soybeans: this.makeRangeObjects((function() {
          var i, results;
          results = [];
          for (x = i = 120; i >= 0; x = i += -5) {
            results.push(x);
          }
          return results;
        })()),
        Wheat: this.makeRangeObjects((function() {
          var i, results;
          results = [];
          for (x = i = 120; i >= 0; x = i += -5) {
            results.push(x);
          }
          return results;
        })())
      };
    };

    ZoneRadioSettingsController.prototype.makeRangeObjects = function(values) {
      var i, index, len, ranges, stopper, val;
      ranges = [];
      stopper = values.length - 2;
      for (index = i = 0, len = values.length; i < len; index = ++i) {
        val = values[index];
        if (index >= stopper) {
          break;
        }
        ranges.push({
          text: values[index + 1] + " - " + val,
          min: val,
          max: values[index + 1],
          index: ranges.length - 1
        });
      }
      ranges.sort(function(a, b) {
        return b.min - a.min;
      });
      return ranges;
    };

    return ZoneRadioSettingsController;

  })(Controller);

}).call(this);
